<template>
  <v-app>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="100"
        color="primary"
      ></v-progress-circular>
    </v-overlay>
    <v-navigation-drawer app v-if="isLogged" v-model="drawer" fixed clipped>
      <v-toolbar flat class="transparent">
        <v-list class="pa-0">
          <v-list-item avatar>
            <v-list-item-avatar color="white">
              <img
                class="responsive"
                src="../../assets/log.png"
                alt="Logo telemon"
              />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Telemon tv</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-toolbar>

      <v-list dense nav>
        <v-list-item
          v-for="item in drawerWithOneOptions"
          :key="item.title"
          :value="item.active"
          :to="item.path"
          v-show="
            item.isVisible
              ? true
              : user != null
              ? user.role == 'employee'
                ? false
                : true
              : true
          "
          :prepend-icon="item.icon"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content class="ml-4">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <!-- lista en grupo -->
      <v-list>
        <!-- <v-divider class="mb-3"></v-divider> -->
        <v-list-group
          v-for="option in drawerOptions"
          :key="option.title"
          :value="option.active"
          v-show="
            option.isVisible
              ? true
              : user != null
              ? user.role == 'employee'
                ? false
                : true
              : true
          "
          :prepend-icon="option.icon"
        >
          <v-list-item slot="activator">
            <v-list-item-content>
              <v-list-item-title v-text="option.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-for="(child, idx) in option.children"
            :key="idx"
            :to="child.path"
          >
            <v-list-item-content>
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-divider class="my-3"></v-divider>
        <v-list-item @click="signOut">
          <v-list-item-action>
            <v-icon>directions_run</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Salir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar v-if="isLogged" app fixed clipped-left>
      <v-btn icon @click.stop="drawer = !drawer">
        <v-icon color="primary">menu</v-icon>
      </v-btn>
      <v-toolbar-title class="primary--text"
        >Telemon | Panel de control</v-toolbar-title
      >
    </v-app-bar>
    <v-content>
      <v-container>
        <router-view
          v-on:show-snackbar="showSnackbar"
          @show-Overlay="showOverlay"
        />
      </v-container>
      <v-snackbar v-model="snackbar.visible" :timeout="3000">
        <span>{{ snackbar.text }}</span>
        <v-btn @click.native="snackbar.visible = false" dark text>Cerrar</v-btn>
      </v-snackbar>
    </v-content>
  </v-app>
</template>
<script>
import { auth } from "../../firebase.config.js";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "Admin",
  data: () => ({
    isLogged: false,
    drawer: null,
    overlay: false,
    userData: {},
    drawerWithOneOptions: [
      {
        icon: "trending_up",
        isVisible: true,
        active: false,

        title: "Principal",
        path: "/admin/dashboard/InitialPage",
      },
      // {
      //    icon: "groups",
      //   isVisible: true,
      //   active: false,

      //   title: "Reportes",
      //   path: "/admin/dashboard/requestsClaim",
      // },
      {
        icon: "public",
        isVisible: false,
        active: false,
        title: "Noticias",
        path: "/admin/dashboard/news",
      },
    ],
    drawerOptions: [
      {
        title: "Solicitudes",

        icon: "mail",
        isVisible: true,
        active: true,
        children: [
          {
            title: "De paquetes",
            path: "/admin/dashboard/package-requests",
          },
          {
            title: "Mensajes desde la web",
            path: "/admin/dashboard/contact-requests",
          },
        ],
      },
      {
        title: "Cambiar Portadas",
        icon: "collections",
        isVisible: false,
        active: false,
        children: [
          {
            title: "Carousel Web",
            path: "/admin/dashboard/corousel",
          },
          {
            title: "Carousel Movil",
            path: "/admin/dashboard/corouselMovil",
          },
        ],
      },
    ],
    snackbar: {
      visible: false,
      text: "",
    },
  }),
  created() {
    auth.onAuthStateChanged((user) => {
      this.isLogged = !!user;
    });
  },
  mounted() {
    this.loadInfo();
  },
  computed: {
    ...mapGetters(["usersAdmin"]),
    username() {
      const displayName = auth.currentUser.displayName;
      return displayName ? displayName : "Bienvenido";
    },
    user() {
      if (this.usersAdmin == null) {
        return null;
      }
      this.usersAdmin.forEach((element) => {
        if (element.email == auth.currentUser.email) {
          this.userData = element;
        }
      });

      return this.userData;
    },
    email() {
      const emailUser = auth.currentUser.email;
      return emailUser ? emailUser : false;
    },
  },
  methods: {
    ...mapActions(["loadAdmin", "singOutAction"]),
    showSnackbar(message) {
      this.snackbar.visible = true;
      this.snackbar.text = message;
    },
    showOverlay(overlay) {
      this.overlay = overlay;
    },
    async loadInfo() {
      await this.loadAdmin();
    },
    signOut() {
      this.singOutAction();
      auth.signOut().then(() => {
        this.$router.replace("/");
      });
    },
  },
};
</script>
